import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import SectionHeading from './SectionHeading';
import { useInView, reveal } from './motion';
import { useT } from '../../i18n/LanguageContext';

const getSteps = (t) => [
  { n: '01', title: t('home.howItWorks.step1Title'), body: t('home.howItWorks.step1Body') },
  { n: '02', title: t('home.howItWorks.step2Title'), body: t('home.howItWorks.step2Body') },
  { n: '03', title: t('home.howItWorks.step3Title'), body: t('home.howItWorks.step3Body') },
];

function Step({ step, i }) {
  const theme = useTheme();
  const { ref, visible } = useInView();
  return (
    <Box ref={ref} sx={{ ...reveal(visible, i * 0.1) }}>
      <Typography sx={{
        fontFamily: theme.home.display, fontWeight: 900, fontSize: { xs: '3.2rem', md: '4rem' },
        color: theme.home.cyanText, lineHeight: 1, opacity: 0.9,
      }}>
        {step.n}
      </Typography>
      <Box sx={{ width: 44, height: 3, bgcolor: theme.home.coralText, my: 2, borderRadius: 2 }} />
      <Typography variant="h3" sx={{ fontSize: { xs: '1.4rem', md: '1.6rem' }, color: theme.home.ink, mb: 1.5 }}>
        {step.title}
      </Typography>
      <Typography sx={{ color: theme.home.inkMuted, lineHeight: 1.65, fontSize: '1.05rem' }}>
        {step.body}
      </Typography>
    </Box>
  );
}

export default function HowItWorks() {
  const theme = useTheme();
  const t = useT();
  const steps = getSteps(t);
  return (
    <Box id="come-funziona" sx={{ bgcolor: theme.home.paper, py: theme.home.sectionPy }}>
      <Box sx={{ maxWidth: theme.home.maxWidth, mx: 'auto', px: { xs: 3, md: 5 } }}>
        <SectionHeading
          eyebrow={t('home.howItWorks.eyebrow')}
          title={t('home.howItWorks.title')}
          lede={t('home.howItWorks.lede')}
        />
        <Box sx={{
          mt: { xs: 5, md: 8 }, display: 'grid', gap: { xs: 5, md: 6 },
          gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
        }}>
          {steps.map((s, i) => <Step key={s.n} step={s} i={i} />)}
        </Box>
      </Box>
    </Box>
  );
}
